const advertisementsPath = '/ads';
export const getAds = advertisementsPath;
export const getPublishedAds = advertisementsPath;
export const getAdById = (id: number) => `${advertisementsPath}/${id}`;
export const createAd = advertisementsPath;
export const updateAd = (id: number) => `${advertisementsPath}/${id}`;
export const updateAdStatus = (id: number) => `${advertisementsPath}/${id}/publishing`;
export const sendAdsNotification = () => '/pushNotification';
